import { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

import Bar from './bar';
import VolumeBar from './volumeBar';
import ControlButton from './button';
import QualitySelector from './qualitySelector';
import ReactTooltip from 'react-tooltip';

interface IVidePlayer {
  curTime: number;
  played: number;
  loaded: number;
  src: string;
  logo_white?: string;
  playing: boolean;
  muted: boolean;
  isHovered: boolean;
  setPlaying: (val: boolean) => void;
  allTime: number;
  handleSeek: (val: number) => void;
  volume: number;
  handleVolume: (val: number) => void;
  handleMute: () => void;
  onClickFullscreen: () => void;
  handleHoverLeave: () => void;
  handleMouseEnter: () => void;
  onChangeBitrate: (e: any) => void;
  player: React.RefObject<ReactPlayer>;
}

export function VideoPlayer({
  curTime,
  played,
  loaded,
  logo_white,
  playing,
  muted,
  isHovered,
  setPlaying,
  allTime,
  handleSeek,
  volume,
  handleVolume,
  onClickFullscreen,
  handleMute,
  player,
  onChangeBitrate,
  handleHoverLeave,
  handleMouseEnter,
}: IVidePlayer) {
  console.log('logo_white', logo_white);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { duration, setClickedTime } = {
    duration: allTime,
    setClickedTime: () => console.log('test'),
  };
  const [path, setPath] = useState('M4 4l12 6-12 6z');

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const playAudio = () => {
    setPlaying(true);
    setPath('M5 4h3v12H5V4zm7 0h3v12h-3V4z');
  };

  const stopAudio = () => {
    setPlaying(false);
    setPath('M4 4l12 6-12 6z');
  };

  return (
    <div
      className={`${
        !isHovered || !playing ? '' : 'hidden'
      } flex flex-wrap content-center flex-col px-2 absolute bottom-0 left-0 right-0 bg-zinc-900 bg-opacity-40`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleHoverLeave}
    >
      <div className="w-full mt-2">
        <Bar
          curTime={curTime}
          played={played}
          loaded={loaded}
          duration={duration}
          onTimeUpdate={(time) => handleSeek(time)}
        />
      </div>
      <div className="w-full grid  grid-cols-2">
        <div className="flex justify-start gap-x-3 items-center">
          <ControlButton
            handleClick={playing ? stopAudio : playAudio}
            path={path}
          />
          <VolumeBar
            volume={volume}
            onTimeUpdate={(volume) => handleVolume(volume)}
            handleMute={handleMute}
            muted={muted}
          />
        </div>

        <div className="flex justify-end gap-3 items-center">
          <a
            href="https://easytest.ma/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {logo_white && (
              <img
                draggable="false"
                className="h-10 cursor-pointer"
                alt="easytest"
                src={logo_white}
              />
            )}
          </a>
          <QualitySelector onChangeBitrate={onChangeBitrate} player={player} />
          <ArrowsPointingOutIcon
            onClick={() => onClickFullscreen()}
            data-tip
            data-for="Fullscreen"
            className="h-6 w-6 cursor-pointer text-white"
          />
          <ReactTooltip id="Fullscreen" place="top" effect="solid">
            <span className="text-xs">FullScreen</span>
          </ReactTooltip>
        </div>
      </div>
    </div>
  );
}
